import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentDeviceService } from '../../core/services/current-device.service';
import { LinkType, MenuItem } from '../../shared/model/menu.model';
import { TargetEntityTypeEnum, TargetTypeEnum } from '../../core/model/mobile-config.model';
import { jsonParse } from '../../shared/pipes/name-translate.pipe';
import { PostConfig } from '../../builtin-pages/post-list/_model/post.model';
import { getMenuNativePath, getSpecialPagePath } from '../../core/utilities/page-route-util';
import { MenuHoverStyleEnum } from '../../shared/model/menu-hover-style.enum';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
    @Input() menu: MenuItem;
    @Input() menuHoverStyle: MenuHoverStyleEnum;
    @Input() enableIcon: boolean;
    MenuHoverStyleEnum = MenuHoverStyleEnum;
    constructor(
        private router: Router,
        public currentDeviceService: CurrentDeviceService,
    ) { }

    getMenuNativePath = getMenuNativePath;

    getSpecialPagePath = getSpecialPagePath;

    navigateMenuPage(item: MenuItem) {
        let path = this.getMenuNativePath(item);
        if (![undefined, null]?.includes(path)) {
            let queryParams: any = {};
            if (item.linkType === LinkType.URL) {
                if (jsonParse(item?.linkOptions)?.targetType === 'NEW_WINDOW') {
                    window.open(item.linkedUrl);
                    return;
                } else {
                    location.href = item.linkedUrl;
                }
            }
            if (jsonParse(item?.linkedPageParams)?.special) {
                queryParams = this.getSpecialPageQueryParams(jsonParse(item?.linkedPageParams));
            }
            if (jsonParse(item?.linkedPageParams)?.targetEntityType === TargetEntityTypeEnum.POST_CATEGORY) {
                if (!queryParams) {
                    queryParams = {};
                }
                queryParams.categoryId = jsonParse(item?.linkedPageParams)?.targetEntityId || jsonParse(item?.linkedPageParams)?.paramsId;
            }
            this.router.navigate([path], {
                queryParams: {
                    ...queryParams,
                    enableHeaderBackBtn: false,
                }
            });
        } else {
            if (item?.children?.length) {
                this.navigateMenuPage(item?.children?.[0]);
            }
        }
    }

    checkCurrentRouterIsActive(item: MenuItem, routerUrl: string): boolean {
        if (!item) {
            return false;
        }
        if (routerUrl === undefined) {
            if (item?.children?.length) {
                return item?.children?.some(menuItem => {
                    if (this.getMenuNativePath(menuItem)) {
                        let result = this.checkCurrentRouterIsActive(item, this.getMenuNativePath(menuItem));
                        if (result) {
                            return result;
                        }
                    }
                    return menuItem?.children?.some(menuChildItem => {
                        if (this.getMenuNativePath(menuItem)) {
                            return this.checkCurrentRouterIsActive(item, this.getMenuNativePath(menuChildItem));
                        } else {
                            return false;
                        }
                    });
                });
            }
            return false;
        }
        return (!['', '/', '/home']?.includes(routerUrl)) ? this.router.isActive(routerUrl, false) : ['', '/', '/home']?.includes(this.router.url?.split(/\?/)?.[0]);
    }

    checkMenuIsActive(item: MenuItem): boolean {
        let isActive = this.checkCurrentRouterIsActive(item, this.getMenuNativePath(item));
        if (isActive) {
            return isActive;
        }
        if (item?.children?.length) {
            return item?.children?.some(menuItem => {
                let result = this.checkCurrentRouterIsActive(menuItem, this.getMenuNativePath(menuItem));
                if (result) {
                    return result;
                }
                return menuItem?.children?.some(menuChildItem => this.checkCurrentRouterIsActive(menuChildItem, this.getMenuNativePath(menuChildItem)));
            });
        }
        return false;
    }

    getSpecialPageQueryParams(linkParams: any) {
        if (linkParams.targetType === TargetTypeEnum.ENTITY) {
            if ([TargetEntityTypeEnum.POST_LIST, TargetEntityTypeEnum.POST_CATEGORY].includes(linkParams.targetEntityType)) {
                return {
                    ...(linkParams.postConfig || new PostConfig),
                    enableHeaderBackBtn: false,
                };
            }
            if (linkParams.targetEntityType === TargetEntityTypeEnum.POST) {
                return {
                    enableHeaderBackBtn: false,
                    ...linkParams.postConfig
                };
            }
            if (linkParams.targetEntityType === TargetEntityTypeEnum.POST_CATEGORY) {
                const params: any = linkParams.postConfig;
                params.categoryId = linkParams.targetEntityId;
                params.enableHeaderBackBtn = false;
                return params;
            }
            if (linkParams.targetEntityType === TargetEntityTypeEnum.PRODUCT_CATEGORY) {
                return {
                    enableHeaderBackBtn: false,
                    categoryId: linkParams.targetEntityId
                };
            }
            if (linkParams.targetEntityType === TargetEntityTypeEnum.PRODUCT) {
                return {
                    enableHeaderBackBtn: false,
                    id: linkParams.targetEntityId
                };
            }
        }
    }
}
